import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';
import {MolodayaArcticaItem} from '../../../shared/models/api/molodayaArticaResponsePayload';

export interface MolodayaArcticaState {
  dataLoading: boolean;
  data: MolodayaArcticaItem[] | null;
}

const initialState: MolodayaArcticaState = {
  dataLoading: false,
  data: null,
};

export const molodayaArcticaSlice = createSlice({
  name: '@@eskmo/molodayaArctica',
  initialState,
  reducers: {
    setDataLoading: (state, {payload}: PayloadAction<MolodayaArcticaState['dataLoading']>) => {
      state.dataLoading = payload;
    },
    setData: (state, {payload}: PayloadAction<MolodayaArcticaState['data']>) => {
      state.data = payload;
    },
    reset: () => initialState,
  },
  extraReducers: {
    [AppActions.Reset]: () => initialState,
  },
});

export const molodayaArcticaActions = molodayaArcticaSlice.actions;

export const molodayaArctica = molodayaArcticaSlice.reducer;
